// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3JnFo","checkboxCol":"Table_checkboxCol__1NW2q","emailCol":"Table_emailCol__118o2","actionCol":"Table_actionCol__2qQOv"};